import React from 'react';
import { useI18n } from '@/i18n/I18nContext';
import { HERO } from '@/constants/testIds';

const HERO_BG =
  'https://images.pexels.com/photos/35458829/pexels-photo-35458829.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=2000';

export const Hero = () => {
  const { t } = useI18n();

  const goContact = (e) => {
    e.preventDefault();
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      data-testid={HERO.root}
      className="relative isolate overflow-hidden min-h-[100svh] flex items-center"
    >
      {/* Background image */}
      <div
        className="absolute inset-0 -z-20 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
        aria-hidden="true"
      />
      {/* Overlay gradient */}
      <div
        className="absolute inset-0 -z-10"
        style={{
          background:
            'linear-gradient(90deg, rgba(5,13,23,0.96) 0%, rgba(5,13,23,0.85) 38%, rgba(5,13,23,0.55) 70%, rgba(5,13,23,0.25) 100%)',
        }}
        aria-hidden="true"
      />
      {/* Bottom navy fade for section blend */}
      <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent to-[#050D17] -z-10" />

      {/* Decorative gold wave (mirrors logo motif) */}
      <svg
        className="absolute right-[-6%] top-1/2 -translate-y-1/2 w-[55%] max-w-[860px] opacity-[0.18] wave-drift hidden md:block"
        viewBox="0 0 600 600"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M20 320 Q150 220 300 320 T580 320"
          stroke="#C9A24E"
          strokeWidth="2"
          fill="none"
        />
        <path
          d="M20 360 Q150 260 300 360 T580 360"
          stroke="#C9A24E"
          strokeWidth="1.2"
          fill="none"
          opacity="0.6"
        />
        <path
          d="M20 400 Q150 300 300 400 T580 400"
          stroke="#C9A24E"
          strokeWidth="0.8"
          fill="none"
          opacity="0.35"
        />
      </svg>

      <div className="container mx-auto px-6 relative">
        <div className="max-w-2xl pt-24 pb-16 fade-up">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-[#C9A24E]" />
            <span className="text-[11px] uppercase tracking-[0.32em] text-[#C9A24E]">
              {t('hero.eyebrow')}
            </span>
          </div>

          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#F2F5F8] leading-[1.05]">
            {t('hero.title')}
          </h1>

          <p className="mt-8 text-base sm:text-lg text-[#C9D2E2] max-w-xl leading-relaxed">
            {t('hero.subtitle')}
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#contact"
              data-testid={HERO.ctaPrimary}
              onClick={goContact}
              className="inline-flex items-center px-7 py-4 bg-[#C9A24E] text-[#050D17] text-[12px] uppercase tracking-[0.22em] font-semibold hover:bg-[#E6CC80] transition-colors"
            >
              {t('hero.ctaPrimary')}
            </a>
            <a
              href="/services"
              data-testid={HERO.ctaSecondary}
              className="inline-flex items-center px-7 py-4 border border-[#C9A24E] text-[#C9A24E] text-[12px] uppercase tracking-[0.22em] hover:bg-[#C9A24E]/10 transition-colors"
            >
              {t('hero.ctaSecondary')}
            </a>
          </div>
        </div>

        {/* Corner contact stripe */}
        <div className="hidden md:flex absolute right-6 bottom-12 items-center gap-6 text-xs text-[#8F9BB3] uppercase tracking-[0.22em]">
          <a href="mailto:info@stcmarineservices.com" className="hover:text-[#C9A24E] transition-colors">
            info@stcmarineservices.com
          </a>
          <span className="h-px w-6 bg-[#C9A24E]/40" />
          <a href="tel:+306973667473" className="hover:text-[#C9A24E] transition-colors">
            +30 6973667473
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
